import React from "react";

import BrewInstallInstructions from "./BrewInstallInstructions";

import styles from "./ReadyForTakeOff.module.css";
import SendDownloadLink from "./SendDownloadLink";

const ReadyForTakeOff: React.FC = () => {
  return (
    <div className={styles.downloadContainer}>
      <h2>Ready for take-off?</h2>
      <p>Download the Raycast app and start taking your productivity to new heights.</p>
      <div className={styles.downloadInfo}>
        <div className={styles.downloadLink}>
          <a
            href="#download"
            onClick={(event) => {
              event.preventDefault();
              window.location.href = "https://api.raycast.app/v2/download";
            }}
            className={styles.callToAction}
          >
            Download for Mac
          </a>
        </div>
        or
        <BrewInstallInstructions />
      </div>

      <div className={styles.sendDownloadLink}>
        <SendDownloadLink />
      </div>

      <span className={styles.versionInfo}>macOS 10.15+</span>
    </div>
  );
};

export default ReadyForTakeOff;
